// @flow
import * as DSToken from './style-dictionary/build/es6/DSToken';

export { DSToken };
export { default as DSTokenMap } from './style-dictionary/build/es6/DSTokenMap';
export { default as Color } from './style-dictionary/build/es6/Color';



// WEBPACK FOOTER //
// ../design-system/index.js